interface DefaultArrowSelectProps {
  className?: string;
  color?: string;
}

const DownloadIcon = ({ color, className }: DefaultArrowSelectProps) => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill={color} className={className}>
        <path d="M4.90648 7.46966L7.37966 10.1776L7.37966 0.5C7.37966 0.223857 7.61159 0 7.89769 0C8.18379 0 8.41572 0.223857 8.41572 0.5L8.41572 10.2355L11.104 7.46966C11.2997 7.26819 11.6275 7.25796 11.8362 7.44681C12.045 7.63567 12.0556 7.95208 11.8599 8.15355L8.27563 11.8419C8.06673 12.0571 7.71134 12.0519 7.50924 11.8308L4.12959 8.13126C3.9403 7.92419 3.96077 7.60822 4.17531 7.42553C4.38984 7.24283 4.7172 7.26259 4.90648 7.46966Z" fill={color} />
        <path d="M16 8.5C16 8.22386 15.7761 8 15.5 8C15.2239 8 15 8.22386 15 8.5V14.9102C15 14.9598 14.9598 15 14.9102 15L1.08983 15C1.04022 15 1 14.9598 1 14.9102L1 8.5C1 8.22386 0.776142 8 0.5 8C0.223858 8 0 8.22386 0 8.5V15.8431C0 15.9298 0.07023 16 0.156863 16L15.8431 16C15.9298 16 16 15.9298 16 15.8431V8.5Z" fill={color} />
      </svg>
    </>
  );
}

export default DownloadIcon;